import { SET_MESSAGE_CONFIRMACAOEMAIL, SET_LOADING_VALUE, SET_ERROR_VALUE } from './types';

const initialState = {
  screenInfo:{
    icon: '',
    title: '',
    discription: '',  
  },
  loading: false
}
export default function confirmacaoEmailReducer(state = initialState, action) {

  switch(action.type){
    case SET_MESSAGE_CONFIRMACAOEMAIL: return {...state, screenInfo: action.payload };
    case SET_LOADING_VALUE: return {...state, loading: action.payload};
    case SET_ERROR_VALUE: return {...state, isError: action.payload};
    default: return state;
  }
}